export const elementErrorSelector = '.v-field--error, .v-input--error, .error, [data-form-error]';
